import { Collection } from '../../../../collections/collections.types';
import { AvailabilityEnum, DeliveryWindow } from '../../../../products/ProductTypes';
import { ColorClassification } from '../../../../products/product.types.v2';
import { PendingOrderProductKeys } from '../../interfaces/orderProducts.helper.interfaces';
import { GroupByColorClassificationTypeInfo, ListCategoryDTO } from '../../orderProducts.types';

export type OrderProductsSorter = {
  availability?: AvailabilityEnum;
  category?: ListCategoryDTO;
  code?: string;
  collection?: Collection;
  deliveryWindow?: DeliveryWindow;
  productColorId?: string;
  subCategory?: ListCategoryDTO;
  colorClassifications?: ColorClassification[];
};

export interface OrderProductsSorterSortParams<T> {
  orderProducts: T[];
  info?: GroupByColorClassificationTypeInfo;
  pendingOrderProductKeys?: PendingOrderProductKeys;
}

abstract class OrderProductsSorterBuilder {
  public abstract sort<T extends OrderProductsSorter>({
    orderProducts,
    pendingOrderProductKeys,
    info,
  }: OrderProductsSorterSortParams<T>): T[];
}

export default OrderProductsSorterBuilder;
